import { TODAY, MONTH_KEY } from "@/data/mock";

export const SHIFT_TOLERANCE = "09:10";
export const ABSENCE = {
  falta: { label: "Falta", tone: "red" },
  ferias: { label: "Férias", tone: "gold" },
  atestado: { label: "Atestado", tone: "dark" },
  folga: { label: "Folga", tone: "muted" },
};
export const DAY_STATE = {
  nao_iniciou: { label: "Não iniciou", tone: "muted" },
  trabalhando: { label: "Trabalhando", tone: "green" },
  pausa: { label: "Em pausa", tone: "gold" },
  encerrada: { label: "Jornada encerrada", tone: "dark" },
};
export const PUNCH_LABEL = { inicio: "Início", pausa: "Pausa", retorno: "Retorno", termino: "Término" };

export const nowHM = () => new Date().toTimeString().slice(0, 5);
const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
export const fmtMin = (m) => `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}`;

export const entryOf = (s, cid, date) => s.timeEntries.find((e) => e.collaboratorId === cid && e.date === date);
export const absenceOn = (s, cid, date) => s.absences.find((a) => a.collaboratorId === cid && date >= a.start && date <= a.end);
export const timeOf = (entry, type) => entry?.events.filter((e) => e.type === type).map((e) => e.time).pop();
export const firstStart = (entry) => entry?.events.find((e) => e.type === "inicio")?.time;

export const dayState = (entry) => {
  const last = entry?.events[entry.events.length - 1]?.type;
  if (!last) return "nao_iniciou";
  return last === "pausa" ? "pausa" : last === "termino" ? "encerrada" : "trabalhando";
};

const intervals = (entry, opens, closes) => {
  if (!entry) return 0;
  let total = 0;
  let from = null;
  entry.events.forEach((e) => {
    if (opens.includes(e.type)) from = toMin(e.time);
    else if (closes.includes(e.type) && from !== null) {
      total += Math.max(0, toMin(e.time) - from);
      from = null;
    }
  });
  if (from !== null && entry.date === TODAY) total += Math.max(0, toMin(nowHM()) - from);
  return total;
};
export const worked = (entry) => intervals(entry, ["inicio", "retorno"], ["pausa", "termino"]);
export const paused = (entry) => intervals(entry, ["pausa"], ["retorno", "termino"]);

const workdays = (a, b) => {
  const from = a < `${MONTH_KEY}-01` ? `${MONTH_KEY}-01` : a;
  const to = b > `${MONTH_KEY}-31` ? `${MONTH_KEY}-31` : b;
  let n = 0;
  for (let d = new Date(`${from}T12:00:00`); d <= new Date(`${to}T12:00:00`); d.setDate(d.getDate() + 1)) n += 1;
  return n;
};

export const monthReport = (s, c) => {
  const entries = s.timeEntries.filter((e) => e.collaboratorId === c.id && e.date.startsWith(MONTH_KEY) && e.events.length);
  const abs = s.absences.filter((a) => a.collaboratorId === c.id);
  const days = (type) => abs.filter((a) => a.type === type).reduce((n, a) => n + workdays(a.start, a.end), 0);
  return {
    days: entries.length,
    minutes: entries.reduce((n, e) => n + worked(e), 0),
    late: entries.filter((e) => (firstStart(e) || "00:00") > SHIFT_TOLERANCE).length,
    falta: days("falta"),
    ferias: days("ferias"),
    atestado: days("atestado"),
    folga: days("folga"),
  };
};
